var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "modalHeader modal-top pos-sticky top-0 zindex-3 p-0" },
      [
        _c(
          "button",
          {
            staticClass: "close rounded-btn display-1 p-10 bg-grey3",
            attrs: { "aria-label": "Close" },
            on: {
              click: function ($event) {
                return _vm.modal.dismiss()
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "font-lato text-light",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "optionsBloc modal-main radius-18 radius-bottom-0 text-left bg-grey3",
      },
      [
        _vm.product.ims
          ? _c("div", { staticClass: "radius-18", attrs: { id: "bigImg" } }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product.ims,
                    expression: "product.ims",
                  },
                ],
                staticClass:
                  "prod-img img-fit img-fluid w-100 min-mt-60 radius-15 radius-bottom-0",
                attrs: {
                  src: _vm.UrlService.imagePath(
                    _vm.product.ShopId,
                    _vm.product.ims
                  ),
                },
                on: {
                  error: function ($event) {
                    $event.target.src = "dist/assets/no-img.png"
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "title display-2 color-grey1 text-bold radius-18 radius-bottom-0 top-0 pos-sticky zindex-2 bg-grey3 pl-20 pr-40 pt-15 pb-5",
          },
          [_vm._v("\n\t\t\t" + _vm._s(_vm.product.dn) + "\n\t\t")]
        ),
        _vm._v(" "),
        _c("p", {
          staticClass: "display-5 color-grey6 px-20 mb-20",
          domProps: { innerHTML: _vm._s(_vm.product.dd) },
        }),
        _vm._v(" "),
        (_vm.product.allergens && _vm.product.allergens.length) ||
        (_vm.product.consumables && _vm.product.consumables.length)
          ? _c("div", { staticClass: "bg-white radius-4 p-20 m-20" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex-between-center color-grey1 fsize-15 cursor-pointer hover-color1 w-100 text-uppercase",
                  on: {
                    click: function ($event) {
                      _vm.blockCollapsed = !_vm.blockCollapsed
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex-start-center w-100" }, [
                    _c("i", {
                      staticClass:
                        "fie-icon_warning-eat mr-10 fsize-24 text-normal",
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm.product.allergens && _vm.product.allergens.length > 1
                        ? _c("span", [_vm._v("Allergènes")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.allergens && _vm.product.allergens.length == 1
                        ? _c("span", [_vm._v("Allergène")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.allergens &&
                      _vm.product.consumables &&
                      _vm.product.allergens.length &&
                      _vm.product.consumables.length
                        ? _c("span", [_vm._v(" & ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.consumables &&
                      _vm.product.consumables.length > 1
                        ? _c("span", [_vm._v("Consommables")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.consumables &&
                      _vm.product.consumables.length == 1
                        ? _c("span", [_vm._v("Consommable")])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fie-icon_dp-arrow ml-5 fsize-9 text-normal",
                    class: { rotate270: _vm.blockCollapsed },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ease-2",
                  class: {
                    "closed opacity-0": _vm.blockCollapsed,
                    "opened opacity-1": !_vm.blockCollapsed,
                  },
                },
                [_c("product-tags", { attrs: { product: _vm.product } })],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "options-nav bg-grey3 pos-sticky border-bottom-grey7 zindex-1 pb-10 px-20",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c("breadcrumbs", {
                  attrs: {
                    list: _vm.join_options,
                    current: _vm.currentOption,
                    id: "OptionGroupId",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.setCurrent(props.item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(props.item.optionGroup.name))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.someOptionsTaken
                  ? _c(
                      "a",
                      {
                        staticClass: "optionsTakenArrow forDesktop",
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            _vm.hideOptionsTaken = !_vm.hideOptionsTaken
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-eatselfapp_three-points fa-rotate-90",
                          class: { closed: !_vm.hideOptionsTaken },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "optionsTakenDesc",
                attrs: { "uib-collapse": "hideOptionsTaken" },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.someOptionsTaken,
                        expression: "!someOptionsTaken",
                      },
                    ],
                    staticClass: "py-5 display-6",
                  },
                  [_vm._v("\n\t\t\t\t\t \n\t\t\t\t")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.someOptionsTaken,
                        expression: "someOptionsTaken",
                      },
                    ],
                    staticClass: "display-6 color-grey2 py-5",
                    attrs: { id: "choicesTaken" },
                  },
                  [
                    _c("span", [
                      _c("b", [_vm._v("Vous avez choisi :")]),
                      _vm._v(
                        " " + _vm._s(_vm.allItemsTakenDesc(_vm.optionCarts))
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "options-container py-40" }, [
          _c(
            "div",
            { staticClass: "scrollBloc" },
            _vm._l(_vm.join_options, function (option, index) {
              return _c(
                "div",
                {
                  key: option.OptionGroupId,
                  ref: "join_options",
                  refInFor: true,
                  staticClass: "option-group",
                  style: {
                    "min-height":
                      index == _vm.join_options.length - 1
                        ? _vm.getHeightMinusHeaders() + "px"
                        : "",
                  },
                  attrs: { id: "option-group-id-" + option.OptionGroupId },
                },
                [
                  _c(
                    "div",
                    { staticClass: "choicesBloc" },
                    [
                      _c("propose-choice", {
                        attrs: {
                          title: option.optionGroup.name,
                          "min-choices": option.minChoices,
                          "max-choices": option.maxChoices,
                          "num-choices-taken": option.numChoicesTaken,
                        },
                        on: {
                          "skip-choice": function ($event) {
                            return _vm.skipOption(option)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass:
                            "choicesBloc--items mx-20 mb-10 p-0 radius-18 shadow-2 no-overflow",
                        },
                        _vm._l(
                          option.optionGroup.choices,
                          function (productId) {
                            return _c(
                              "div",
                              { key: productId },
                              [
                                _vm.products[productId] &&
                                _vm.products[productId].av == true
                                  ? _c("product-option-choice", {
                                      attrs: {
                                        cart: _vm.optionCarts[option.index],
                                        choice:
                                          _vm.optionCarts[option.index][
                                            productId
                                          ],
                                        "option-product":
                                          _vm.products[productId],
                                        "join-option": option,
                                        "join-prices": _vm.cartItem.joinPrices,
                                      },
                                      on: {
                                        "choice-taken": function ($event) {
                                          return _vm.onOptionTakenCb()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }